import { object, string } from 'prop-types';
import { ChatButton } from '@shoflo/polymer';
import { UncontrolledTooltip } from 'reactstrap';
import React, { useEffect, useState, useRef } from 'react';

import ChatWidget from './ChatWidget';
import { StyledChatButtonWrapper } from './ChatWrapper.styled';

function ChatWrapper({ user, teamId, eventId, broadcastId }) {
  let firstName = '';

  let lastName = '';

  if (user) {
    firstName = user.firstName;

    lastName = user.lastName;
  }

  const [isOpen, setIsOpen] = useState(false);
  const iframeRef = useRef();

  const chatButtonTooltip = 'Private chat with the host and speakers';

  const CHAT_URL = `/chat/team/${teamId}/event/${eventId}/broadcast/${broadcastId}/director/chat?firstName=${firstName}&lastName=${lastName}`;

  const { location } = window;

  const { host, protocol } = location;

  const baseUrl = `${protocol}//${host}`;

  function onChatToggle(event) {
    const { data } = event;

    if (data === 'chat:toggle') {
      setIsOpen(!isOpen);
    }
  }

  useEffect(() => {
    window.addEventListener('message', onChatToggle, false);

    return () => {
      window.removeEventListener('message', onChatToggle);
    };
  });

  function onPopOutClick() {
    setIsOpen(!isOpen);

    window.open(`${baseUrl}${CHAT_URL}`, 'Chat', 'height=1000,width=600');
  }

  function onToggleChat() {
    const nextState = !isOpen;

    iframeRef.current.contentWindow.postMessage(`chatIsOpen:${nextState}`, '*');
    setIsOpen(!isOpen);
  }

  return (
    <>
      <StyledChatButtonWrapper>
        <ChatButton
          id="chat-button"
          isOpen={isOpen}
          onClick={onToggleChat}
          data-testid="chat-button"
        />
        {isOpen !== true ? (
          <UncontrolledTooltip placement="left" target="chat-button">
            {chatButtonTooltip}
          </UncontrolledTooltip>
        ) : null}
      </StyledChatButtonWrapper>
      <ChatWidget
        ref={iframeRef}
        isChatOpen={isOpen}
        onPopOutClick={onPopOutClick}
        chatURL={`${baseUrl}${CHAT_URL}`}
      />
    </>
  );
}

ChatWrapper.propTypes = {
  user: object,
  teamId: string,
  eventId: string,
  broadcastId: string,
};

export default ChatWrapper;
